import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {Comment} from '../../types'

export const CommentsQueryKey = 'comments'

type CommentsPayload = {
  from: string
  to: string
  locationId: string
}

export const getCommentsPath = (locationId: string) => `/kpi/dashboard/comments/${locationId}`

export const useComments = (
  {from, to, locationId}: CommentsPayload,
  options?: Omit<UseQueryOptions<Comment[], AxiosError>, 'queryKey' | 'queryFn'>
) => {
  return useQuery<Comment[], AxiosError>({
    queryKey: [CommentsQueryKey, from, to, locationId],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<Comment[]>(getCommentsPath(locationId), {
        params: {from, to},
        signal
      })
      return response.data
    },
    staleTime: Infinity,
    ...options
  })
}
